import { X, RotateCcw } from "lucide-react";
import { ASSUMPTION_GROUPS, DECK_THEME as T, fmt$, fmtPct } from "../../lib/deckModel";

export function AssumptionsDrawer({ open, onClose, a, onChange, onReset, model, sessionOnly }) {
  const bs = model.exits.find((e) => e.key === "build_sell");
  return (
    <div className={`fixed inset-0 z-[90] ${open ? "" : "pointer-events-none"}`} data-testid="deck-assumptions-drawer" aria-hidden={!open}>
      <div onClick={onClose} className={`absolute inset-0 transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0"}`} style={{ background: "rgba(24,54,80,0.55)" }} />
      <aside className={`absolute right-0 top-0 h-full w-full sm:w-[440px] flex flex-col transition-transform duration-300 ease-out ${open ? "translate-x-0" : "translate-x-full"}`} style={{ background: T.warm, fontFamily: T.sans }}>
        <div className="px-6 pt-6 pb-6 text-white" style={{ background: T.navy }}>
          <div className="flex items-start justify-between">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/60" style={{ fontFamily: T.mono }}>Interactive Underwriting</div>
              <div className="mt-1 text-3xl" style={{ fontFamily: T.serif }}>Assumptions</div>
              <div className="mt-1 text-sm text-white/70">{sessionOnly ? "Session only. Every section recalculates live." : "Saved with the deck. Every section recalculates live."}</div>
            </div>
            <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/10 transition-colors" data-testid="deck-assumptions-close"><X className="h-5 w-5" /></button>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-y-4 gap-x-6">
            {[["NOI", fmt$(model.noi)], ["Stabilized value", fmt$(model.value)], ["Build + Sell profit", fmt$(bs?.net)], ["Profit on cost", fmtPct(bs?.poc)]].map(([k, v]) => (
              <div key={k}><div className="text-[10px] uppercase tracking-[0.2em] text-white/60" style={{ fontFamily: T.mono }}>{k}</div>
                <div className="text-2xl tabular-nums" style={{ fontFamily: T.serif }} data-testid={`deck-drawer-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{v}</div></div>
            ))}
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-6 space-y-7">
          {ASSUMPTION_GROUPS.map((g) => (
            <div key={g.title}>
              <div className="text-[10px] uppercase tracking-[0.25em] mb-3" style={{ color: T.muted, fontFamily: T.mono }}>{g.title}</div>
              <div className="rounded-2xl border bg-white divide-y" style={{ borderColor: T.line }}>
                {g.fields.map(([k, l, t]) => (
                  <label key={k} className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm" style={{ color: T.charcoal, borderColor: T.neutral }}>
                    <span>{l}</span>
                    <span className="flex items-center rounded-lg border px-2.5 py-1.5 w-32" style={{ borderColor: T.line }}>
                      {t === "money" && <span className="text-xs mr-1" style={{ color: T.muted }}>$</span>}
                      <input inputMode="decimal" value={a[k] ?? ""} onChange={(e) => onChange({ ...a, [k]: e.target.value })} className="w-full text-right outline-none bg-transparent tabular-nums" data-testid={`deck-drawer-input-${k}`} />
                      {t === "pct" && <span className="text-xs ml-1" style={{ color: T.muted }}>%</span>}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          ))}
          {onReset && <button onClick={onReset} className="w-full flex items-center justify-center gap-2 rounded-full border py-2.5 text-sm hover:bg-white transition-colors" style={{ borderColor: T.line, color: T.navy }} data-testid="deck-assumptions-reset"><RotateCcw className="h-4 w-4" />Reset to deck assumptions</button>}
        </div>
      </aside>
    </div>
  );
}
